import moment from "moment-timezone"

const DatePlugin = {
  install(Vue, options) {
    Vue.prototype.$userTimezone = options && options.timezone ? options.timezone : moment.tz.guess()

    Vue.prototype.formatDate = (date, withTime = true) => {
      if (!date) return null

      return moment(date).tz(Vue.prototype.$userTimezone).format(
        withTime ? "DD/MM/YYYY à HH[h]mm" : "DD/MM/YYYY"
      )
    }

    Vue.prototype.$setUserTimezone = (timezone) => {
      if (timezone) {
        Vue.prototype.$userTimezone = timezone
      }
    }
  },
}

export default DatePlugin
